export const name = 'ooi' as const
export const ReactLoaderForOOISymbol = Symbol.for('loader')
export const OOISsrManagerSymbol = Symbol.for('OOISsrManager')
